import { AppTextLink } from '@9b3kuq5phwuk4txw/kiban-react-ui'

interface LinkifiedTextProps {
  text: string
}

/**
 * テキスト内のURLを自動検出してAppTextLinkでリンク化するコンポーネント
 */
export function LinkifiedText({ text }: LinkifiedTextProps) {
  const urlPattern = /(https?:\/\/[^\s<]+)/g
  const parts = text.split(urlPattern)

  return (
    <>
      {parts.map((part, index) =>
        /^https?:\/\//.test(part) ? (
          <AppTextLink key={`${index}-${part}`} href={part} external>
            {part}
          </AppTextLink>
        ) : (
          <span key={`${index}-${part}`}>{part}</span>
        ),
      )}
    </>
  )
}
